import { useGretaAIChatContext } from './GretaAIChat.hooks'
import { GretaAIChatPanel } from './GretaAIChatPanel'
import { GretaAIChatPortal } from './GretaAIChatPortal'

function GretaAIChat() {
  const { panel } = useGretaAIChatContext()

  return panel.isOpen ? (
    <GretaAIChatPortal>
      <GretaAIChatPanel />
    </GretaAIChatPortal>
  ) : null
}

export default GretaAIChat
